(function () {
  'use strict';

  var STORAGE_KEY = 'submittedFormType';

  var FORM_LABELS = {
    'questions-or-feedback': 'Questions or Feedback form',
    concern: 'Concern or Complaint form',
    practitioner: 'Healthcare Practitioner form',
    'press-or-media': 'Press or Media form',
    'retailer-or-wholesale-inquiries': 'Retailer or Wholesale Inquiries form',
    other: 'Other form'
  };

  function initGxContactRoot(root) {
    if (!root || root.dataset.gxContactInit === 'true') return;
    root.dataset.gxContactInit = 'true';

    var selector = root.querySelector('[data-gx-contact-select]');
    var liveRegion = root.querySelector('[data-gx-contact-live]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-gx-contact-panel]'));

    if (!selector || !panels.length) return;

    function getPanel(key) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-form-key') === key) return panels[i];
      }
      return null;
    }

    function hideAllPanels() {
      panels.forEach(function (panel) {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });
    }

    function showPanel(key) {
      hideAllPanels();
      var panel = getPanel(key);
      if (!panel) return;

      panel.hidden = false;
      panel.classList.add('is-active');

      if (liveRegion && FORM_LABELS[key]) {
        liveRegion.textContent = FORM_LABELS[key] + ' displayed.';
      }

      var form = panel.querySelector('form');
      if (form) bindFormValidation(form);
    }

    function restoreSelection() {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved && getPanel(saved)) {
        selector.value = saved;
        showPanel(saved);
      }
    }

    selector.addEventListener('change', function () {
      var selected = selector.value;
      root.querySelectorAll('.form-success').forEach(function (msg) {
        msg.style.display = '';
      });

      if (selected && getPanel(selected)) {
        showPanel(selected);
        localStorage.setItem(STORAGE_KEY, selected);
      } else {
        hideAllPanels();
        localStorage.removeItem(STORAGE_KEY);
        if (liveRegion) liveRegion.textContent = 'No form selected.';
      }
    });

    restoreSelection();

    var url = new URL(window.location.href);
    if (url.searchParams.has('contact_posted')) {
      var submittedType = localStorage.getItem(STORAGE_KEY);
      if (submittedType && getPanel(submittedType)) {
        selector.value = submittedType;
        showPanel(submittedType);
        setTimeout(function () {
          var panel = getPanel(submittedType);
          var successEl = panel ? panel.querySelector('.form-success') || panel : null;
          if (successEl) {
            var topOffset = successEl.getBoundingClientRect().top + window.scrollY - 300;
            window.scrollTo({ top: topOffset, behavior: 'smooth' });
          }
        }, 400);
      }
      setTimeout(function () {
        window.history.replaceState({}, document.title, '/pages/contact');
      }, 1000);
    }

    panels.forEach(function (panel) {
      var form = panel.querySelector('form');
      if (form && panel.classList.contains('is-active')) bindFormValidation(form);
    });
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
  }

  function clearFieldError(field) {
    field.removeAttribute('aria-invalid');
    field.classList.remove('gx-contact__input--error');
    var describedBy = field.getAttribute('aria-describedby');
    if (describedBy) {
      var errorEl = document.getElementById(describedBy);
      if (errorEl && errorEl.classList.contains('gx-contact__error')) errorEl.remove();
      field.removeAttribute('aria-describedby');
    }
  }

  function setFieldError(field, message) {
    clearFieldError(field);
    var errorId = field.id + '_error';
    field.setAttribute('aria-invalid', 'true');
    field.classList.add('gx-contact__input--error');
    var span = document.createElement('span');
    span.id = errorId;
    span.className = 'gx-contact__error';
    span.textContent = message;
    field.setAttribute('aria-describedby', errorId);
    field.parentNode.appendChild(span);
  }

  function validateField(field) {
    var value = String(field.value || '').trim();
    var required = field.hasAttribute('data-required');
    var minLength = parseInt(field.getAttribute('data-minlength') || '0', 10);
    var type = field.getAttribute('type') || field.tagName.toLowerCase();

    if (required && !value) {
      setFieldError(field, field.getAttribute('data-error-required') || 'This field is required.');
      return false;
    }

    if (type === 'email' && value && !isValidEmail(value)) {
      setFieldError(field, field.getAttribute('data-error-email') || 'Please enter a valid email address.');
      return false;
    }

    if (minLength > 0 && value && value.length < minLength) {
      setFieldError(field, field.getAttribute('data-error-minlength') || 'Please enter at least ' + minLength + ' characters.');
      return false;
    }

    clearFieldError(field);
    return true;
  }

  function validateForm(form) {
    var fields = form.querySelectorAll('[data-validate]');
    var valid = true;
    var firstInvalid = null;

    fields.forEach(function (field) {
      if (!validateField(field)) {
        valid = false;
        if (!firstInvalid) firstInvalid = field;
      }
    });

    if (firstInvalid) firstInvalid.focus();
    return valid;
  }

  function bindFormValidation(form) {
    if (form.dataset.gxValidateBound === 'true') return;
    form.dataset.gxValidateBound = 'true';

    form.querySelectorAll('[data-validate]').forEach(function (field) {
      field.addEventListener('blur', function () {
        if (String(field.value || '').trim()) validateField(field);
      });
    });

    form.addEventListener('submit', function (event) {
      if (!validateForm(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      var button = form.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = true;
        button.classList.add('gx-contact__submit--loading');
        var textEl = button.querySelector('.gx-contact__submit-text');
        if (textEl) textEl.textContent = 'Submitting...';
      }

      if (window.Shopify && window.Shopify.recaptchaV3) {
        event.preventDefault();
        window.Shopify.recaptchaV3.execute(form);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-gx-contact-root]').forEach(initGxContactRoot);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
